export default "__VITE_ASSET__B_42Yq0i__"